/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import React, { Component } from 'react';
import { $window, classSet } from '@umu/umu-dom';
import * as ImageUtil from '@umu/umu-image-handle';
import { IUserMedal } from '@umu/umu-types';
import { components } from 'common';
const { If, PreImg } = components;

import UserLevelBadge, { TUserLevelSize } from '../userLevelBadge/userLevelBadge';
import UserMedalIcon from '../userMedalIcon/userMedalIcon';
import './userAvatar.scss';

export interface IProps {
    id?: string;
    className: string;
    src: string;
    width?: number;
    index?: number;
    userLevelInfo?: number;
    userMedalInfo?: IUserMedal;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16 | 12;
    userLevelSize?: TUserLevelSize;
    href?: string;
    jumpWidthSelf?: boolean;
    isToProfile?: boolean;
    isStudentId?: boolean;
    isLogin?: boolean;
    onClick?: () => void;
}

interface IState {
    loadFail: boolean;
}

import defaultAvatar from '../../../images/default-avatar-radiu.png';
import { isFromCourseMiniApp } from '../../../@utils/umuUtil';
import { goUserProfile } from '../../../services';

export default class UserAvatar extends Component<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);

        this.loadError = this.loadError.bind(this);

        this.state = {
            loadFail: false,
        };
    }

    public loadError() {
        this.setState({
            loadFail: true,
        });
    }

    public renderAvatarImage() {
        const { src, width = 40 } = this.props;
        const style = {
            width: `${width / 100}rem`,
            height: `${width / 100}rem`,
        };

        const imgSrc = !this.state.loadFail && src ? ImageUtil.appendWidth(src, width * 2) : defaultAvatar;
        return (
            <div className="user-avatar-image img" style={style}>
                <PreImg>
                    <img src={imgSrc} onError={this.loadError} />
                </PreImg>
            </div>
        );
    }

    public redirectToProfileHome = (href = '') => {
        const { id, isToProfile, isStudentId = true, onClick } = this.props;

        if (onClick) {
            onClick();
        }

        if (isToProfile && id) {
            goUserProfile(id, isStudentId);
            return;
        }

        if (!href) {
            return;
        }

        if (isFromCourseMiniApp()) {
            return;
        }

        const jumpWidthSelf = this.props.jumpWidthSelf;
        $window.open(href, jumpWidthSelf ? '_self' : '_blank');
    };

    public render() {
        const {
            className,
            isToProfile,
            userMedalInfo,
            showUserLevel = 0,
            userLevelInfo = 0,
            userMedalWidth = 20,
            userLevelSize,
            href = '',
            isLogin = true,
        } = this.props;

        const userLevelHolderSize = userLevelSize ? ' size-' + userLevelSize : '';
        const cursor = (!!href || isToProfile) && isLogin ? 'cursor' : '';

        return (
            <div
                className={classSet('user-avatar-info', className, cursor)}
                onClick={() => this.redirectToProfileHome(href)}
            >
                {this.renderAvatarImage()}
                <If condition={!!showUserLevel && userLevelInfo !== 0}>
                    <div className={'user-level-info-holder' + userLevelHolderSize}>
                        <UserLevelBadge userLevelInfo={+userLevelInfo} userLevelSize={userLevelSize} />
                    </div>
                </If>
                <If condition={!!showUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type}>
                    <div className="user-medal-info-holder">
                        <UserMedalIcon userMedalInfo={userMedalInfo!} userMedalWidth={userMedalWidth} />
                    </div>
                </If>
            </div>
        );
    }
}
